// src/components/contact/ContactSection.js
import React, { useEffect, useState } from 'react';
import './Contact.css';

const ContactSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to check if screen width is mobile size
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 600); // Set mobile breakpoint at 600px
    };

    // Initial check
    checkMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkMobile);

    // Clean up event listener
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // If mobile, don't render the component
  if (isMobile) {
    return null;
  }

  return (
    <div className="contact-section-wrapper">
      {/* Top header component that overlaps with Btn */}
      <div className="top-wrapper">
        <div className="top-container">
          <div className="header-text">
            まずは気軽にご相談ください！
          </div>
        </div>
      </div>
      
      {/* Btn component */}
      <div className="btn-container">
        {/* Mask group for the left image */}
        <div className="mask-group-container">
          <div className="mask-group">
            {/* Main container with the image and gradient overlay */}
            <div className="rectangle-106">
              <img 
                src={process.env.PUBLIC_URL + '/images/w_model_call.png'} 
                alt="Customer Support" 
                className="model-call-image" 
              />
              {/* Gradient overlay that sits on top of the image */}
              <div className="gradient-overlay"></div>
            </div>
          </div>
        </div>
        
        {/* Frame 193 - All phone info */}
        <div className="frame-193-container">
          <div className="frame-193">
            {/* Top row with icon, label and hours */}
            <div className="phone-label-row">
              {/* Phone icon */}
              <div className="phone-icon-circle">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M14.6667 11.28V13.28C14.6675 13.4657 14.6294 13.6494 14.555 13.8195C14.4807 13.9897 14.3716 14.1424 14.2348 14.2679C14.0979 14.3934 13.9364 14.489 13.7605 14.5485C13.5847 14.6079 13.3983 14.63 13.2134 14.6133C11.1619 14.3904 9.19137 13.6894 7.46004 12.5667C5.84926 11.5431 4.48359 10.1774 3.46004 8.56665C2.33336 6.82745 1.6322 4.84731 1.41337 2.78665C1.39671 2.60229 1.41862 2.41649 1.4777 2.24107C1.53679 2.06564 1.63175 1.90444 1.75655 1.76773C1.88134 1.63102 2.03324 1.52179 2.20256 1.447C2.37189 1.37221 2.55493 1.33349 2.74004 1.33332H4.74004C5.06357 1.33013 5.37723 1.4447 5.62254 1.65567C5.86786 1.86664 6.02809 2.15961 6.07337 2.47998C6.15779 3.12003 6.31434 3.74847 6.54004 4.35332C6.62973 4.59193 6.64915 4.85126 6.59597 5.10057C6.5428 5.34988 6.41928 5.57872 6.24004 5.75998L5.39337 6.60665C6.34241 8.27568 7.72434 9.65761 9.39337 10.6067L10.24 9.75998C10.4213 9.58074 10.6501 9.45722 10.8994 9.40405C11.1488 9.35088 11.4081 9.37029 11.6467 9.45998C12.2516 9.68568 12.88 9.84224 13.52 9.92665C13.8439 9.97234 14.1396 10.1355 14.3511 10.385C14.5625 10.6345 14.6748 10.953 14.6667 11.28Z" fill="white"/>
                </svg>
              </div>
              
              {/* Label and hours on the same line */}
              <div className="label-hours-container">
                <span className="label-text">ほごらんど専用ダイヤル</span>
                <span className="hours-text">(受付時間) 年中無休 10:00~19:00</span>
              </div>
            </div>
            
            {/* Phone number on a separate line */}
            <div className="phone-number">
              <div className="phone-number-text">
                03-6737-7589
              </div>
            </div>
          </div>
        </div>
        
        {/* Frame 188 - Diagnosis button section */}
        <div className="frame-188-container">
          <div className="frame-188">
            <div className="frame-198">
              <div className="frame-199">
                {/* Logo component */}
                <div className="logo-component">
                  {/* Rectangle 1598 with logo image */}
                  <div className="rectangle-1598">
                    <img 
                      src={process.env.PUBLIC_URL + '/images/hogoland_logo.png'} 
                      alt="ほごらんど Logo" 
                      className="hogoland-logo" 
                    />
                  </div>
                  {/* 生活保護診断 text */}
                  <div className="diagnosis-label">生活保護診断</div>
                </div>
                
                {/* Free Diagnosis Button */}
                <a href="https://hogoland.net/simulator/" target="_blank" rel="noopener noreferrer" className="free-diagnosis-btn" style={{ textDecoration: 'none' }}>
                  {/* Task list icon */}
                  <div className="task-list-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="37" viewBox="0 0 34 37" fill="none">
                      <g clipPath="url(#clip0_35_106)">
                        <path d="M28.1252 32.4681C28.1252 33.1417 27.8723 33.7878 27.4223 34.2639C26.972 34.7401 26.3617 35.0078 25.7252 35.0078H4.1251C3.48857 35.0078 2.87813 34.7401 2.42803 34.2639C1.97795 33.7878 1.7251 33.1417 1.7251 32.4681V4.53163C1.7251 3.85805 1.97795 3.21208 2.42803 2.7358C2.87813 2.25952 3.48857 1.99194 4.1251 1.99194H17.531C18.1675 1.99194 18.778 2.25952 19.228 2.7358L27.4223 11.4068C27.8723 11.8831 28.1252 12.5291 28.1252 13.2026V32.4681Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M16.2656 16.9126H22.2656" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M16.2656 25.7222H22.2656" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M6.98438 25.5783L8.99531 27.7063L12.3469 22.741" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M6.98438 16.61L8.99531 18.738L12.3469 13.7727" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_35_106">
                          <rect width="33.6" height="35.5556" fill="white" transform="translate(0 0.722168)"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>

                  {/* Frame 196 - Content container */}
                  <div className="frame-196">
                    {/* Frame 195 - Time input container */}
                    <div className="frame-195">
                      <span className="time-input-text">60秒・かんたん入力</span>
                    </div>
                    {/* Main text */}
                    <div className="diagnosis-text-contact">無料診断はこちら</div>
                  </div>

                  {/* Subtract icon */}
                  <div className="subtract-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="35" viewBox="0 0 36 35" fill="none">
                      <path fillRule="evenodd" clipRule="evenodd" d="M18.1001 35C27.7651 35 35.6001 27.165 35.6001 17.5C35.6001 7.83502 27.7651 0 18.1001 0C8.43511 0 0.600098 7.83502 0.600098 17.5C0.600098 27.165 8.43511 35 18.1001 35ZM23.3304 17.7594C23.8196 17.3593 23.8196 16.6114 23.3304 16.2113L16.6452 10.7434C15.9922 10.2093 15.0121 10.6739 15.0121 11.5174L15.0121 22.4533C15.0121 23.2968 15.9922 23.7614 16.6452 23.2273L23.3304 17.7594Z" fill="white"/>
                    </svg>
                  </div>
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;